export const input = (theme) => ({
    /* Styles applied to the root element. */
    root: {
        "& .MuiFilledInput-input": {
            // padding: "10px 20px",
            // marginBottom: "-5px",
            fontSize: 16,
            fontWeight: "normal",
            fontFamily: "Spezia",
            color: theme.customPalette.neutralGr04,
        },
        "& .MuiFilledInput-multiline": {
            // padding: "10px 0",
            fontSize: 16,
            fontWeight: "normal",
            fontFamily: "Spezia",
            color: theme.customPalette.neutralGr04,
        },
        "& .MuiFilledInput-root": {
            borderRadius: 0,
        },
    },
    filled: {
        // borderBottom: `2px solid ${theme.customPalette.trueGreen}`,
    },
    underline: {
        "&&&:before": {
            borderBottom: "none",
        },
        "&&:after": {
            borderBottom: "none",
        },
    },
    multiline: {
        height: "fit-content",
    },
});
